import {Header, Icon} from "semantic-ui-react";
import React from "react";
import {PaymentDetails} from "./PaymentDetailsContainer";
import UseDifferentPaymentMethod from "./useDifferentPaymentMethod";
import StripePaymentError from "./stripePaymentError";

const flexInlineStyles = {
    display: "flex",
    justifyContent: "space-between",
    margin: "0"
};

const BankAccountInfo = ({YourCost, removeBankAccount, strings}) => {
    const {
        bankAccountPmData,
        removePm,
    } = PaymentDetails.useContainer()

    const showIsVerified = () => {
        if(!bankAccountPmData || !bankAccountPmData.metadata){
            return false
        }
        const {metadata} = bankAccountPmData
        return metadata.verificationStatus &&  metadata.verificationStatus === "manually_verified"
    }

    const getBankName = bankAccountData =>  bankAccountData.bank_name? bankAccountData.bank_name: bankAccountData.brand

    return (
        <>
            <StripePaymentError strings={strings} paymentMethod={strings.bankAccount}/>
            <Header as="h5"><strong>{strings.bankAccount}</strong></Header>
            <div style={flexInlineStyles}>
                <p className={'neutral700Text'}>{`${getBankName(bankAccountPmData)}...${bankAccountPmData.last4}`}</p>
                {showIsVerified() &&
                    <p className={"primaryHeaderColor small"}>
                        <Icon name="checkmark"/> <span style={{fontWeight: "bold"}}>Verified</span>
                    </p>
                }
            </div>
            { YourCost }
            <UseDifferentPaymentMethod strings={strings} hideMethod={() => {removeBankAccount(bankAccountPmData.id); removePm()}} />
        </>
    );
}

export default BankAccountInfo;
